import axios from 'axios';
import useUtils from '../../components/hooks/useUtils';
const { isEmptyObj } = useUtils();

const state = {
	config: {},
}

const mutations = {
	SET_CONFIG(state, config) {
		state.config = config.data;
	},
}

const actions = {
	fetchConfig({ commit }) {
		return new Promise((resolve, reject) => {
			if (isEmptyObj(state.config)) {
				return axios.get('/api/config')
				.then(response => {
					commit('SET_CONFIG', response.data);
					resolve();
				})
				.catch(function(error) {
					commit('UPDATE_ERROR', error);
					reject();
				});
			} else {
				resolve();
			}
		});
	},
}

const getters = {
	config: state => state.config,
}

const configModule = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

export default configModule;
